import { render, staticRenderFns } from "./OrganizationTagSettings.vue?vue&type=template&id=69324b23&scoped=true"
import script from "./OrganizationTagSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationTagSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTagSettings.vue?vue&type=style&index=0&id=69324b23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69324b23",
  null
  
)

export default component.exports